// A link-styled action (FR-047; research R14): text in `prt`, a 44 px target, button role unless it
// navigates. Extra props pass through, so it works inside expo-router's `Link asChild`.
import { PressableTarget, type PressableTargetProps } from "./PressableTarget";
import { Text } from "./Text";

export type LinkButtonProps = Omit<
  PressableTargetProps,
  "children" | "accessibilityLabel" | "accessibilityRole"
> & {
  children: string;
  role?: "button" | "link";
};

export function LinkButton({
  children,
  role = "button",
  disabled,
  ...rest
}: LinkButtonProps) {
  return (
    <PressableTarget
      {...rest}
      accessibilityRole={role}
      accessibilityLabel={children}
      accessibilityState={{ disabled: !!disabled }}
      disabled={disabled}
    >
      <Text tone={disabled ? "muted" : "primary"} weight="semiBold">
        {children}
      </Text>
    </PressableTarget>
  );
}
